import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";
import * as React from "react";

import { cn } from "@/shared/utils/cn";

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer relative grid size-11 min-h-11 min-w-11 shrink-0 place-content-center rounded-xl text-primary-foreground before:absolute before:left-1/2 before:top-1/2 before:size-[22px] before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-[6px] before:border before:border-input before:bg-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:before:border-primary data-[state=checked]:before:bg-primary data-[state=indeterminate]:before:border-primary data-[state=indeterminate]:before:bg-primary",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className="group/indicator relative grid place-content-center text-current"
    >
      <Check aria-hidden="true" className="size-4 group-data-[state=indeterminate]/indicator:hidden" />
      <Minus aria-hidden="true" className="hidden size-4 group-data-[state=indeterminate]/indicator:block" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
